import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ImplementerNameInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Nombre de la implementadora">
      {getFieldDecorator("implementerName", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el nombre de la implementadora."
          }
        ],
        initialValue: implementerProfile?.implementerName
      })(
        <Input
          disabled={isBusy}
          id="implementerName"
          name="implementerName"
          placeholder="Nombre de la implementadora"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
